import { IApiClient } from '../../app/data/client';
import { BasePageState } from '../../app/shared/BasePageState';
import { IMemento } from '../../app/shared/common';

export class EmptyPageState extends BasePageState<IMemento> {
  constructor(client: IApiClient) {
    super({ pageTitleFormat: 'Empty Page', pageDescriptionFormat: null });
  }
}
